module.exports = __webpack_public_path__ + "static/media/medusa.8c7c988e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/medusa.jpeg
// module id = 289
// module chunks = 0